import Highcharts, { PointOptionsObject } from 'highcharts'

import { formatNumber } from 'Utils/number'

export interface ChartDataPoint extends PointOptionsObject {
  name: string
  y: number
  invalidRate?: number
  drilldown?: string
}

export interface DrilldownSeries {
  id: string
  name: string
  type: 'pie'
  data: ChartDataPoint[]
}

export type SeriesPieOptions = {
  data: Array<ChartDataPoint>
}

export const PieColors = ['#E92165', '#F15A8C', '#F591B2', '#FFB3C6', '#FF6F91']

export const ChartOptions: Highcharts.Options = {
  legend: {
    itemStyle: {
      fontFamily:
        '"Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    },
    labelFormatter: function (this: Highcharts.Point | Highcharts.Series) {
      if ('y' in this) {
        return `${this.name}: ${formatNumber(this.y ?? 0)}`
      }
      return this.name
    },
    useHTML: true,
    itemHoverStyle: {
      cursor: 'pointer',
    },
  },
  tooltip: {
    formatter: function (this: Highcharts.TooltipFormatterContextObject) {
      if (this.point && 'y' in this.point) {
        return `${this.point.name}: ${(this.point.y ?? 0).toLocaleString()}`
      }
      return this.point?.name ?? ''
    },
  },
}
